import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import config from '../../config';
import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './LandingPageCareer.css';
import {
    SectionHero,
    SectionReasonsToJoinUs,
    SectionVacancies,
    SectionOurPriorities,
    SectionTeamAndLocations,
} from '../LandingPage/sectionsCareer';
import { getLpSchemaObj, facebookImages, twitterImages } from '../LandingPage/common/helpers';

export const LandingPageCareer = ({ scrollingDisabled }) => {
    const schemaTitle = 'Offene Stellen | Karriere bei HorseDeal';
    const schemaDescription =
        'Hier findest Du alle Stellen bei HorseDeal auf einen Blick. Bring mit uns den Pferdesport ins digitale Zeitalter. Mehr erfahren und bewerben.';

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            schema={getLpSchemaObj(schemaTitle, schemaDescription)}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer currentPage="CareerPage" />
                </LayoutWrapperTopbar>
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <div className={css.container}>
                        <SectionHero />
                        <SectionReasonsToJoinUs />
                        <SectionVacancies />
                        <SectionOurPriorities />
                        <SectionTeamAndLocations />
                    </div>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};

const { bool, object, array } = PropTypes;

LandingPageCareer.propTypes = {
    scrollingDisabled: bool.isRequired,

    // from withRouter
    history: object.isRequired,
    location: object.isRequired,

    // from injectIntl
    intl: intlShape.isRequired,
};

const mapStateToProps = ({ UI }) => ({
    scrollingDisabled: isScrollingDisabled({ UI }),
});

export default compose(connect(mapStateToProps), injectIntl)(LandingPageCareer);
